import React, { useState, useRef } from "react";

import { Row } from "antd";
import { ChatLeft, ChatRight } from "./components";
import "@assets/css/ChatHistory.css";
import "@assets/css/ChatUi.css";
import "@assets/css/CopilotlyChatHistory.css";
const Chats = () => {
  const [chatInput, setChatInput] = useState({ message: "" });
  const [conversation, setConversation] = useState([]);
  const [isResponseLoading, setIsResponseLoading] = useState(false);
  const [errorText, setErrorText] = useState("");
  const scrollToLastItem = useRef(null);

  // Build Open Ai messages array
  const buildOpenAIMessagesArray = (messages) => {
    let openAIMessages = [];

    messages?.forEach((message) => {
      // Check if the input is not deleted and add it with 'user' role
      if (message.role === "user") {
        openAIMessages.push({
          role: "user",
          content: message.content,
        });
      }

      // Check if the generated text is not deleted and add it with 'system' role
      if (message.role === "system") {
        openAIMessages.push({
          role: "system",
          content: message.content,
        });
      }
    });

    return openAIMessages;
  };

  // Submit Handler
  const handleSendMessage = async () => {
    console.log("hittitng");
    // e.preventDefault();

    if (!chatInput) return;
    setChatInput("");

    setIsResponseLoading(true);

    // Create a messages array
    const messages = buildOpenAIMessagesArray(conversation);
    // Add the current message to the messages array
    messages.push({
      role: "user",
      content: chatInput.message,
    });

    const OPEN_AI_TOKEN = "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";

    try {
      // fetch open.ai API
      const response = await fetch(
        "https://api.openai.com/v1/chat/completions",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${OPEN_AI_TOKEN}`,
          },
          body: JSON.stringify({
            model: "gpt-3.5-turbo",
            messages: messages,
            stream: true,
          }),
        }
      );

      if (!response.ok) {
        setErrorText("Failed to fetch data ");
        throw new Error("Failed to fetch data");
      }

      if (response.status === 429) {
        return setErrorText("Too many requests, please try again later.");
      }

      const responseText = await response.text(); // Get the entire response as text

      const lines = responseText.split("\n");

      // // ParsedLines
      const parsedLines = lines
        .map((line) => line.replace(/^data: /, "").trim()) // Trim whitespace from each line
        .filter((line) => {
          return line !== "" && line !== "[DONE]"; // Filter lines starting with "[DONE]"
        })
        .map((line) => {
          return JSON.parse(line);
        });

      let accumulatedWords = "";
      let showMessage = [];

      parsedLines?.forEach((parsedLine, index) => {
        const { choices } = parsedLine;
        const { delta } = choices[0];
        const { content } = delta;
        if (content) {
          accumulatedWords += content;
          showMessage.push(content);
        }
      });

      // Generate streaming text
      generateStreamingText(showMessage);

      if (accumulatedWords.length > 0) {
        setErrorText("");
        // save this accumulatedWords to the backend
        // setConversation([
        //   ...conversation,
        //   { role: "user", content: text },
        //   { role: "system", content: accumulatedWords },
        // ]);

        setTimeout(() => {
          setChatInput("");
        }, 2);
        setIsResponseLoading(false);
      }
    } catch (error) {
      console.error("Error occurred", error);
    }
  };

  // Generate streaming text
  const generateStreamingText = async (showMessage) => {
    const delay = () => new Promise((resolve) => setTimeout(resolve, 10));
    let accumulatedText = "";
    for (let i = 0; i < showMessage.length; i++) {
      accumulatedText += showMessage[i] + " ";
      setConversation([
        ...conversation,
        { role: "user", content: chatInput.message },
        { role: "system", content: accumulatedText },
      ]);
      await delay();
    }
    // Scroll to the bottom of the chatContainer
    const chatContainer = document.getElementById("chatMessageContainer");

    if (chatContainer) {
      setTimeout(() => {
        chatContainer.scrollTo({
          top: chatContainer.scrollHeight,
          behavior: "smooth",
        });
      }, 0);
    }
  };

  return (
    <>
      <Row
        style={{
          overflow: "hidden",
          boxShadow: "rgba(0, 0, 0, 0.1) 0px 18px 2px",
        }}
      >
        {/* Left Chats List */}
        <ChatLeft />

        {/* Middle Chatbot Messages and Right Chatbot Visitor */}
        <>
          <ChatRight
            // Chat
            chatInput={chatInput}
            setChatInput={setChatInput}
            conversation={conversation}
            setConversation={setConversation}
            handleSendMessage={handleSendMessage}
          />
        </>
      </Row>
    </>
  );
};

export default Chats;
